import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import isNumber from 'lodash/isNumber';
import isString from 'lodash/isString';
import toString from 'lodash/toString';
import { VALIDATION_PATTERN } from '../const/validation.const';
import { DATE_FORMAT_KEYS, DATE_REGEXP } from '../const/date.const';
export const createValidationResult = (isValid, message = '') => {
    return {
        isValid,
        message: isValid ? undefined : message,
    };
};
export function isRequired(value, message = '', whiteSpaceMessage = 'Please enter a valid value') {
    const isOnlyWhitespaces = /^\s+$/.test(toString(value));
    const internalMessage = isOnlyWhitespaces ? whiteSpaceMessage : message || 'This field is required';
    const isValid = (!isEmpty(value) || isNumber(value)) && !isOnlyWhitespaces;
    return createValidationResult(isValid, internalMessage);
}
export function isEmail(value, message = 'Invalid email') {
    const isValid = isString(value) && VALIDATION_PATTERN.email.test(value);
    return createValidationResult(isValid, message);
}
export function isAlphanumeric(value, message = 'Invalid alphanumeric value') {
    const stringifiedValue = isNumber(value) ? toString(value) : value;
    const isValid = VALIDATION_PATTERN.alphanumeric.test(stringifiedValue);
    return createValidationResult(isValid, message);
}
export function isAscii(value, message = 'Invalid ASCII value') {
    const stringifiedValue = isNumber(value) ? toString(value) : value;
    const isValid = VALIDATION_PATTERN.ascii.test(stringifiedValue);
    return createValidationResult(isValid, message);
}
export function isMinLength(value, length = 3, message = `Too short. Minimum length is ${length} characters`) {
    const stringifiedValue = isNumber(value) ? toString(value) : value;
    const isValid = (stringifiedValue || '').length >= length;
    return createValidationResult(isValid, message);
}
export function isPattern(value, pattern, label = '', message = `Entered value doesn\'t match the desired format${label ? `: ${label}` : ''}`) {
    const stringifiedValue = isNumber(value) ? toString(value) : value;
    const isValid = !pattern || pattern.test(stringifiedValue);
    return createValidationResult(isValid, message);
}
export function isWeakPassword(value, message = 'Weak password') {
    const stringifiedValue = isNumber(value) ? toString(value) : value;
    const isValid = VALIDATION_PATTERN.weakPassword.test(stringifiedValue);
    return createValidationResult(isValid, message);
}
export function isMediumPassword(value, message = 'Medium password') {
    const stringifiedValue = isNumber(value) ? toString(value) : value;
    const isValid = VALIDATION_PATTERN.mediumPassword.test(stringifiedValue);
    return createValidationResult(isValid, message);
}
export function isStrongPassword(value, message = 'Strong password') {
    const stringifiedValue = isNumber(value) ? toString(value) : value;
    const isValid = VALIDATION_PATTERN.strongPassword.test(stringifiedValue);
    return createValidationResult(isValid, message);
}
export function isPositiveInteger(value, message = 'The value should be a whole number greater than zero') {
    const stringifiedValue = isNumber(value) ? toString(value) : value;
    const isValid = VALIDATION_PATTERN.positiveInteger.test(stringifiedValue);
    return createValidationResult(isValid, message);
}
export function isValidDateFormat(value, key = DATE_FORMAT_KEYS.default, message = 'Invalid date format') {
    const stringifiedValue = isNumber(value) ? toString(value) : value;
    const DATE_PATTERN = get(DATE_REGEXP, key);
    const isValid = DATE_PATTERN.test(stringifiedValue);
    return createValidationResult(isValid, message);
}
